import { Button } from "@/components/ui/button";
import {
  Dialog,
  DialogContent,
  DialogDescription,
  DialogFooter,
  DialogHeader,
  DialogTrigger,
} from "@/components/ui/dialog";
import { Textarea } from "@/components/ui/textarea";
import { Check, X, ThumbsUp } from "lucide-react";
import { useState } from "react";
import { cn } from "@/lib/utils";
import { colors } from "@/utils/colors";
import { approveAbsence, rejectAbsence } from "@/Api/absences";
import { useToastNavigate } from "@/utils/toastNavigate";
import { LoaderSpin } from "@/components/Loaders";

export const DecideAbsenceBtns = ({
  uuid,
  onDecided,
}: {
  uuid: string;
  onDecided: () => void;
}) => {
  const { toast } = useToastNavigate();
  const [approving, setApproving] = useState(false);
  const [isRejectOpen, setIsRejectOpen] = useState(false);
  const [rejectNote, setRejectNote] = useState("");
  const [rejecting, setRejecting] = useState(false);

  const handleApprove = async () => {
    setApproving(true);
    const { data, ok } = await approveAbsence(uuid);
    setApproving(false);
    if (!ok) {
      toast({
        description: data?.message || "Erro ao aprovar",
        variant: "destructive",
      });
      return;
    }
    toast({ description: "Abono aprovado!", action: <Check color="#1edc2b" /> });
    onDecided();
  };

  const handleReject = async () => {
    if (rejectNote.trim().length < 5) return;
    setRejecting(true);
    const { data, ok } = await rejectAbsence(uuid, rejectNote);
    setRejecting(false);
    if (!ok) {
      toast({
        description: data?.message || "Erro ao reprovar",
        variant: "destructive",
      });
      return;
    }
    setIsRejectOpen(false);
    setRejectNote("");
    toast({ description: "Abono reprovado." });
    onDecided();
  };

  return (
    <div className="flex gap-2">
      <Button
        type="button"
        size="sm"
        className={cn(colors.bg_primary)}
        disabled={approving}
        onClick={handleApprove}
      >
        {approving ? <LoaderSpin /> : <ThumbsUp className="size-4" />}
        Aprovar
      </Button>

      <Dialog open={isRejectOpen} onOpenChange={setIsRejectOpen}>
        <DialogTrigger asChild>
          <Button type="button" size="sm" variant="destructive">
            <X className="size-4" />
            Reprovar
          </Button>
        </DialogTrigger>
        <DialogContent className="sm:max-w-[400px]">
          <DialogHeader>
            <DialogDescription className="text-lg">
              Motivo da reprovação
            </DialogDescription>
          </DialogHeader>
          <Textarea
            value={rejectNote}
            onChange={(e) => setRejectNote(e.target.value)}
            placeholder="Explique por que o abono está sendo reprovado (mín. 5 caracteres)"
          />
          <DialogFooter>
            <Button
              type="button"
              variant="destructive"
              className="w-full"
              disabled={rejecting || rejectNote.trim().length < 5}
              onClick={handleReject}
            >
              {rejecting ? <LoaderSpin /> : "Confirmar reprovação"}
            </Button>
          </DialogFooter>
        </DialogContent>
      </Dialog>
    </div>
  );
};
